import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from './index.module.css';

export default function InputErrorMessage({ visible }) {
  return (
    <div className={classNames(Styles.error, { [Styles.visible]: visible })}>
      單日預算不得低於$500，不然將影響成效
    </div>
  );
}

InputErrorMessage.propTypes = {
  visible: PropTypes.bool,
};

InputErrorMessage.defaultProps = {
  visible: false,
};
